import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { UiKit } from 'components';
import NavItem from '../NavItem';
import ConnectStoreOption from './ConnectStoreOption';
import ChangePasswordOption from './ChangePasswordOption';
import AccountSettingsOption from './AccountSettingsOption';
import { AuthContext } from 'context/AuthContext';
import { ReactComponent as UserIcon } from 'assets/img/icons/user.svg';
import { ReactComponent as LogoutIcon } from 'assets/img/icons/logout.svg';

export default function User({ children = null }) {
  const { push } = useHistory();

  const { userData } = useContext(AuthContext);

  const email = _get(userData, 'email', '');

  const onLogout = () => push('/logout');

  return (
    <UiKit.Dropdown align="right" className={styles.container}>
      <UiKit.Dropdown.Trigger caret={false} component={NavItem}>
        <UserIcon />
      </UiKit.Dropdown.Trigger>
      <UiKit.Dropdown.Menu align="right" className={styles.menu}>
        <UiKit.Dropdown.Option disabled className={styles.emailOption}>
          <div className="truncate">{email}</div>
        </UiKit.Dropdown.Option>
        {children}
        <UiKit.Dropdown.Option onClick={onLogout} className={styles.logout}>
          <LogoutIcon className={styles.icon} />
          Logout
        </UiKit.Dropdown.Option>
      </UiKit.Dropdown.Menu>
    </UiKit.Dropdown>
  );
}

User.ConnectStoreOption = ConnectStoreOption;
User.ChangePasswordOption = ChangePasswordOption;
User.AccountSettingsOption = AccountSettingsOption;
